import React from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { searchRoute } from './util'
import { rootRouters } from '.'
import {LocalKeysEnum,localGet} from '../core/local'
/**
 * @description 路由守卫组件
 * */
const AuthRouter = (props: { children: JSX.Element }) => {
    const loction = useLocation()
    const route = searchRoute(loction.pathname, rootRouters)

    // * 判断当前路由是否需要访问权限(不需要权限直接放行)
    if (!route.meta?.requiresAuth) return props.children

    // * 判断是否有Token
    const token = localGet(LocalKeysEnum.TOKEN)
    const url = '/login' +  loction.search
    if (!token) return <Navigate to={url} replace />
    return props.children
}

export default AuthRouter
